export const SaudiRiyal = ({ className, color = 'currentColor' }: { className?: string, color?: string }) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_7318_7768)'>
      <path
        d='M9.59056 13.404C9.35858 13.8996 9.20523 14.4375 9.14648 15.0016L14.0557 13.996C14.2877 13.5005 14.4409 12.9625 14.4998 12.3984L9.59056 13.404Z'
        fill={color}
      />
      <path
        d='M14.0559 10.9819C14.2879 10.4864 14.4413 9.94842 14.5 9.38436L10.6759 10.168V8.66151L14.0558 7.96941C14.2878 7.47388 14.4411 6.9359 14.4999 6.37184L10.6758 7.15486V1.73689C10.0898 2.05391 9.5694 2.4759 9.14638 2.97365V7.4682L7.61699 7.78143V1C7.03102 1.31691 6.51062 1.73901 6.0876 2.23677V8.09455L2.66558 8.79522C2.43359 9.29075 2.28013 9.82874 2.22127 10.3928L6.0876 9.60109V11.4983L1.94407 12.3467C1.71209 12.8423 1.55875 13.3802 1.5 13.9443L5.83711 13.0562C6.19017 12.9854 6.49362 12.7843 6.69091 12.5075L7.48631 11.3713V11.371C7.56888 11.2535 7.61699 11.1117 7.61699 10.9591V9.28786L9.14638 8.97463V11.9877L14.0558 10.9817L14.0559 10.9819Z'
        fill={color}
      />
    </g>
    <defs>
      <clipPath id='clip0_7318_7768'>
        <rect width='13' height='14' fill='white' transform='translate(1.5 1)' />
      </clipPath>
    </defs>
  </svg>
)
